import type { stacks } from "@dropbox/api-v2-client/types";
import type { ReportPapEventFn } from "@mirage/analytics/AnalyticsProvider";
import { PAP_Rename_DashLink } from "@mirage/analytics/events/types/rename_dash_link";
import { updateStackItem } from "@mirage/service-stacks";
import {
  stackDerivePAPProps,
  stackItemSetName,
} from "@mirage/service-stacks/service/utils";
import { useCallback } from "react";

export const useRenameStackItem = (
  isNewStack: boolean,
  stack: stacks.Stack | null,
  reportPapEvent: ReportPapEventFn,
) => {
  return useCallback(
    async (itemToEdit: stacks.StackItem, newName: string) => {
      if (isNewStack || !stack) return;

      reportPapEvent(
        PAP_Rename_DashLink({
          ...stackDerivePAPProps(stack),
          featureLine: "stacks",
        }),
      );

      await updateStackItem(
        stack.namespace_id ?? "",
        stackItemSetName(itemToEdit, newName),
      );
    },
    [isNewStack, reportPapEvent, stack],
  );
};
